import React from 'react'
import { View, ScrollView, Text, Platform, Dimensions } from 'react-native'
import { VFButton, VFText, VFImageHeader } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import PropTypes from 'prop-types'

import ShowMoreText from '../../Components/ShowMoreText'
import AddOnsExtraData from '../../Components/AddOnsExtraData'

import styles from './CatalogueDetails.Styles'
import { Images } from '../../Themes'

import { getThemeImages } from '../../Themes/Modes'

const BUCKET_ICONS = (images) => {
  return {
    minnderkomb: images.minutes,
    internet: images.internet,
    minkomb: images.minutes,
    smskomb: images.sms,
    smskombnder: images.sms,
    smsvod: images.sms,
    roamoutmin: images.minutes,
    roaminmin: images.minutes,
    roaminternet: images.internet,
    roamsms: images.sms,
    roamoutvfmin: images.minutes,
    validity: images.validity,
    businesspass: images.business_pass,
    videopass: images.video_pass,
    musicpass: images.music_pass,
    gamingpass: images.gaming_pass,
    socialpass: images.social_pass,
    mappass: images.maps_pass,
    chatpass: images.chat_pass,
    combopass: images.combo_pass,
  }
}

function CatalogueDetails({
  title,
  name,
  price,
  duration,
  description,
  unit,
  onPressActionButton,
  onBack,
  onClose,
  withTray,
  showMoreData,
  detailsImage,
}) {

  const theme = useTheme()

  const themeImages = getThemeImages(theme.name)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={{ paddingHorizontal: '10%', paddingTop: 64, overflow: 'scroll' }}>
        <VFImageHeader
          image={Images[detailsImage] || Images.first_image}
          showClose={false}
          hideMainHeader
          title={name}
          showBack
          titleTextAccessibilityLabel={`${name} title id`}
          closeButtonAccessibilityLabel={`${name} close button label`}
          backButtonAccessibilityLabel={`${name} back button label`}
          closeButtonTestID="closeButtonAddOnsView"
          backButtonTestID="backcButtonAddOnsView"
        />
        <ScrollView contentContainerStyle={[styles.scrollContainer(withTray), { paddingBottom: 100 }]}>
          <View>
            <VFText
              style={styles.headerText}
              i18nKey={title}
              accessibilityLabel={`${name} subtitle label`}
            />
            <Text style={styles.priceContainer}>
              <VFText i18nKey={price} style={styles.priceValue} />
              <VFText i18nKey={unit} style={styles.unitValue} />
              <VFText
                i18nKey="catalogue_details_label_duration"
                placeHolders={[duration]}
                style={styles.durationText}
              />
            </Text>
            <AddOnsExtraData
              isExpanded={true}
              showMoreData={showMoreData}
              images={BUCKET_ICONS}
            />
            <View
              style={styles.description}
              accessibilityLabel={`${name} description`}
            >
              <ShowMoreText
                text={description}
                showLessText="catalogue_details_label_show_less"
                showMoreText="catalogue_details_label_show_more"
              />
            </View>
          </View>
          <VFButton
            title="catalogue_details_action_buy"
            style={[styles.mainButton, { marginBottom: 45 }]}
            textStyle={styles.textStyle}
            onPress={onPressActionButton}
            textAccessibilityLabel={`${name} button label`}
            testID="AddOnDetailsActionBtn"
          />
        </ScrollView>
      </ View>
    )
  }

  return (
    <>
      <VFImageHeader
        image={Images[detailsImage] || Images.first_image}
        title={name}
        showBack
        showClose={false}
        onClose={onClose}
        onBack={onBack}
        titleTextAccessibilityLabel={`${name} title id`}
        closeButtonAccessibilityLabel={`${name} close button label`}
        backButtonAccessibilityLabel={`${name} back button label`}
        closeButtonTestID="closeButtonAddOnsView"
        backButtonTestID="backcButtonAddOnsView"
      />
      <ScrollView contentContainerStyle={styles.scrollContainer(withTray)}>
        <View>
          <VFText
            style={styles.headerText}
            i18nKey={title}
            accessibilityLabel={`${name} subtitle label`}
          />
          <Text style={styles.priceContainer}>
            <VFText i18nKey={price} style={styles.priceValue} />
            <VFText i18nKey={unit} style={styles.unitValue} />
            <VFText
              i18nKey="catalogue_details_label_duration"
              placeHolders={[duration]}
              style={styles.durationText}
            />
          </Text>
          <AddOnsExtraData
            isExpanded={true}
            showMoreData={showMoreData}
            images={BUCKET_ICONS(themeImages)}
            theme={theme}
          />
          <View
            style={styles.description}
            accessibilityLabel={`${name} description`}
          >
            <ShowMoreText
              text={description}
              showLessText="catalogue_details_label_show_less"
              showMoreText="catalogue_details_label_show_more"
            />
          </View>
        </View>
        <VFButton
          title="catalogue_details_action_buy"
          style={styles.mainButton}
          textStyle={styles.textStyle}
          onPress={onPressActionButton}
          textAccessibilityLabel={`${name} button label`}
          testID="AddOnDetailsActionBtn"
        />
      </ScrollView>
    </>
  )
}

CatalogueDetails.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.string,
  duration: PropTypes.string,
  description: PropTypes.string,
  unit: PropTypes.string,
  onPressActionButton: PropTypes.func,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  withTray: PropTypes.bool,
  showMoreData: PropTypes.arrayOf([
    PropTypes.objectOf({
      icon: PropTypes.string,
      label: PropTypes.string,
      amount: PropTypes.number,
      unit: PropTypes.string,
    }),
  ]),
  detailsImage: PropTypes.string,
}

export default CatalogueDetails
